import { useMemo } from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'
import { useGetMeQuery } from '../../../../store/user/user'
import { ContactAdminSettings } from './AdminSettingsTabs/InboundMappingSettings/ContactMappingSettings/ContactAdminSettings'
import { SessionAdminSettings } from './AdminSettingsTabs/OutboundMappingSettings/SessionMappingSettings/SessionAdminSettings'

export const usePredefinedAdminSettings = (serviceId: IntegrationServiceId) => {
  const accountId = useAppSelector(selectAccountId)

  const { data: userData } = useGetMeQuery({ accountId }, { refetchOnMountOrArgChange: true })

  const hasIntegration = useMemo(() => {
    if (!userData || !userData.integrations) {
      return false
    }
    return !!userData.integrations.some((i) => i.serviceId === serviceId)
  }, [userData, serviceId])

  const predefinedMeetingSummaryAdminSettings = useMemo(
    () => [
      {
        id: 'meetingSummary',
        label: 'Meeting Summary',
        content: () => <SessionAdminSettings serviceId={serviceId} disabled={!hasIntegration} />,
        disabled: !hasIntegration,
      },
    ],
    [hasIntegration, serviceId],
  )
  const predefinedContactAdminSettings = useMemo(
    () => [
      { id: 'contact', label: 'Contact', content: () => <ContactAdminSettings serviceId={serviceId} disabled={!hasIntegration} />, disabled: !hasIntegration },
    ],
    [hasIntegration, serviceId],
  )
  const predefinedAdminSettings = useMemo(
    () => [...(serviceId === IntegrationServiceId.ZOHO ? predefinedContactAdminSettings : []), ...predefinedMeetingSummaryAdminSettings],
    [serviceId, predefinedContactAdminSettings, predefinedMeetingSummaryAdminSettings],
  )

  return predefinedAdminSettings
}
